<template>
  <PHelpModal :title="title" :intro="intro" :steps="steps" :notes="notes"/>
</template>

<script>
import PHelpModal from "@/domain/core/components/PHelpModal.vue";

export default {
  name: "CheckinTransitiveInferenceHelp",
  components: {PHelpModal},
  computed: {
    title() {
      return this.$pgettext('transitive_inference.help', 'How Check-in Transitive Inference works')
    },
    intro() {
      return this.$pgettext('transitive_inference.help',
          'A selfie can be taken days away from the event — different light, beard, hat — so it may miss some photos. ' +
          'Faces photographed at the event match each other better than they match the selfie. ' +
          'This feature uses the best matched photos as new search references to find the missing ones.')
    },
    steps() {
      return [
        {
          title: this.$pgettext('transitive_inference.help', 'The selfie searches the event photos'),
          text: this.$pgettext('transitive_inference.help',
              'At check-in, the guest\'s selfie is compared with every face detected in the event photos. The matching photos are delivered to the guest.')
        },
        {
          title: this.$pgettext('transitive_inference.help', 'The system checks if more photos are needed'),
          text: this.$pgettext('transitive_inference.help',
              'If the guest has already received enough photos (30), the search stops here.')
        },
        {
          title: this.$pgettext('transitive_inference.help', 'The most reliable matches become new references'),
          text: this.$pgettext('transitive_inference.help',
              'Up to 3 faces of the guest are selected among the matched photos, starting from the ones recognized with the highest reliability.')
        },
        {
          title: this.$pgettext('transitive_inference.help', 'Each reference searches the photos again'),
          text: this.$pgettext('transitive_inference.help',
              'Being photographed at the event, these faces find photos the selfie alone would miss. Each search uses a strict reliability threshold based on the quality of the reference face.')
        },
        {
          title: this.$pgettext('transitive_inference.help', 'The extra photos are delivered'),
          text: this.$pgettext('transitive_inference.help',
              'The newly found photos are added to the guest\'s delivery, up to 30 photos in total.')
        }
      ]
    },
    notes() {
      return [
        this.$pgettext('transitive_inference.help',
            'Only photos taken within the guest\'s check-in validity period can be delivered.'),
        this.$pgettext('transitive_inference.help',
            'Photos found this way are never reused for further searches: the expansion runs once per check-in.'),
        this.$pgettext('transitive_inference.help',
            'When this option is off, the expansion still runs when Autotag and Magic Tag are enabled and the upload is completed. Enabling it forces the expansion at every check-in.')
      ]
    }
  }
}
</script>
